import { OmniaPromise, omniaResolve } from "../omnia"
import { ISoilService } from "../types"
import { getHsaFromSoilService } from "./analysis/hsa"
import { getStdAnalysisFromSoilService } from "./analysis/std"
import { PlanApiData, PlanField } from "./types"

export class PlanApi {


    private data: PlanApiData

    constructor(
        private readonly svc: ISoilService,
        private readonly session = svc.getSession()
    ) {
    }


    load(auto = true): OmniaPromise<PlanApiData> {


        const { svc, session, data } = this
        const { http, yearId: year } = session

        if (auto && data) {
            return omniaResolve()
        }

        const url = `/api/soil/smp/v1?year=${year}`

        return svc.ensureInit()
            .then(() => http.get(url))
            .then(r => {

                const d: PlanApiData = r.data

                this.data = {
                    year,
                    plans: d.plans ?? [],
                    fields: d.fields ?? [],
                    observations: d?.observations ?? { actions: [], observations: [] },
                    userObservations: d?.userObservations,
                    analysis: {
                        std: getStdAnalysisFromSoilService(svc, year),
                        sa: r.data["soilAssessments"],
                        hsa: getHsaFromSoilService(svc, year)
                    }
                }

                return this.data

            })

    }

    resetCurrentYear() {

        const { session } = this
        const { http, yearId: year } = session

        const url = `/api/soil/smp/v1/year/${year}`

        return http.delete(url).then(() => this.load(false))

    }

    setupCurrentYear(sourceYear: number) {

        const { session } = this
        const { http, yearId: year } = session

        const url = `/api/soil/smp/v1/year/${year}/setup?sourceYear=${sourceYear}`

        return http.put(url).then(() => this.load(false))

    }

    get unit() {
        return this.svc.units.soil
    }

    get year() {
        return this.svc.yearId
    }

    get fields() {
        return this.svc.fields
    }

    get devmode() {
        return this.session.debugMode
    }

    get referenceObservations() {
        return this.data.observations
    }

    saveField(field: PlanField) {

        const { session: { http, yearId: year } } = this

        field = { ...field, year }

        const url = `/api/soil/smp/v1/fields`

        return http.post(url, field).then(r => r.data as PlanField)

    }

    updateUserObservation(update: { observation: string, action?: string, remove: boolean }) {

        const { session: { http } } = this

        const url = `/api/soil/smp/v1/observations/user`

        return http.post(url, update)

    }

}
